'use strict';

import ModalView from '../../js/components/ModalView';
import CsrImpersonationFormModal from './templates/_CsrImpersonationFormModal.hbs';
import LoggedInCustomerCsrImpersonationBarTemplate from './templates/_CsrImpersonationLoggedInCustomer.hbs';
import config from '../../js/config';
import * as globalisation from '../../utilities/globalisation';
import userService from '../../services/CartUserService';
import $ from 'jquery';
import cookies from 'js-cookie';
import cacheCookieHelper from '../../components/CacheCookieHelper/CacheCookieHelper';


export default class CsrImpersonationModal extends ModalView {
  initialize($csrImpersonationBar, csrData) {
    super.initialize({ template: CsrImpersonationFormModal });
    this.$csrImpersonationBar = $csrImpersonationBar;
    this.model = {};
    this.model.csrFullName = csrData.csrFullName;
    this.emailExists = null;
    this.emailForgotten = null;
  }
  initializeElements() {
    this.$form = this.$('.CsrImpersonationForm');
    this.$errors = this.$('.CsrImpersonationFormModal-errors');
    this.$email = this.$('#CsrImpersonationForm-email');
    this.$email.focus(() => { this.emailExists = true; this.emailForgotten = false; });
  }

  createValidator() {
    this.validator = this.$form.validate(this._getValidatorConfig());
    this.$email.rules('add',  {emailExists: {}, emailForgotten: {}});
  }

  _getValidatorConfig() {
    $.validator.addMethod(
      'emailExists', () => {
        return this.emailExists;
      });
    $.validator.addMethod(
      'emailForgotten', () => {
        return !this.emailForgotten;
      });
    let emailTranslation = globalisation.pluraliseAndTranslate('forms', 'email');
    return {
      errorClass: config.classes.isInvalid,
      validClass: config.classes.isValid,
      errorElement: 'strong',
      wrapper: 'li',
      errorLabelContainer: this.$errors,
      messages: {
        email: {
          required: globalisation.pluraliseAndTranslate('formValidation', 'requiredFieldName', { fieldName: emailTranslation }),
          email: globalisation.pluraliseAndTranslate('formValidation', 'email'),
          emailExists: globalisation.pluraliseAndTranslate('csrImpersonation', 'existingCustomerEmail'),
          emailForgotten: globalisation.pluraliseAndTranslate('csrImpersonation', 'forgottenCustomerEmail')
        }
      }
    }
  }

  onOpen() {
    this.initializeElements();
    this.emailExists = true;
    this.emailForgotten = false;
    this.createValidator();
  }

  onConfirm() {
    // Already doing something
    if (this.$form.hasClass(config.classes.loadingClass)) {
      return;
    }
    let emailAddress = this.$email.val();
    if (!emailAddress) {
      this.validator.form();
      return;
    }
    this.$('[data-remodal-action="confirm"]').addClass(config.classes.loadingClass);
    userService.checkIfUserExists(emailAddress).then((response) => {
      if (response && !response.error) {
        this.emailExists = true;
        this.emailForgotten = false;
        this.validator.form();
        if (!this.validator.numberOfInvalids()) {
          this.onSuccess(emailAddress);
        }
      } else if (response && response.error && response.error.messages[0].message === config.csrImpersonation.userForgottenResponse) {
        this.emailExists = true;
        this.emailForgotten = true;
        this.$('[data-remodal-action="confirm"]').removeClass(config.classes.loadingClass);
        this.validator.form();
      }
      else {
        this.emailExists = false;
        this.emailForgotten = false;
        this.$('[data-remodal-action="confirm"]').removeClass(config.classes.loadingClass);
        this.validator.form();
      }
    });
  }

  onSuccess(emailAddress) {
    if (emailAddress) {
      userService.checkIfUserExists(emailAddress).then((response) => {
        if (response && !response.error) {
          userService.csrCustomerCheckout(emailAddress, '').then((csrCustomerCheckoutResponse) => {
            if (csrCustomerCheckoutResponse) {
              this.model.csrRole =  globalisation.pluraliseAndTranslate('csrImpersonation', 'csrRoleTitle');
              this.model.customerFullname = csrCustomerCheckoutResponse.fullName;
              this.model.customerCheckoutText = globalisation.pluraliseAndTranslate('csrImpersonation', 'signedInAs');
              this.model.customerEmailAddress = csrCustomerCheckoutResponse.email;
              this.model.arrowAccountText = globalisation.pluraliseAndTranslate('csrImpersonation', 'arrowAccount');
              this.$csrImpersonationBar.html(LoggedInCustomerCsrImpersonationBarTemplate(this.model));
              this.$elCustomerDetails = this.$csrImpersonationBar.find('.CsrImpersonationBar-csr-details')
              this.$elCustomerDetails.css('opacity', '0.7');
              cookies.set(config.cookies.csrSignedInAsCustomer, true);
              if (cacheCookieHelper) {
                cacheCookieHelper.setCacheCookie();
              }
              this.close('confirmation');
              window.location.reload();
            }
          });
        }
      });
    }
  }

};



// WEBPACK FOOTER //
// ./assets/components/CsrImpersonationBar/CsrImpersonationModal.js